import { observer } from 'mobx-react-lite'
import { ReactElement } from 'react'
import { VehicleSpecificationItem } from '../../../../store/models/VehicleSpecification'
import { Grid } from '@mui/material'
import styled from 'styled-components'
import { Delete } from '@mui/icons-material'
import { defaultTheme } from '../../../../theme/index'
import { Translate } from 'common'

interface SpecificationRowInterface {
  specification: VehicleSpecificationItem
  removeSpecification: (hash: string) => void
}

export const SpecificationRow = observer(
  (vehicleSpecification: SpecificationRowInterface): ReactElement => {
    const { specification, removeSpecification } = vehicleSpecification
    return (
      <StyledGrid
        container
        direction="row"
        className="py-4"
        alignItems="center"
      >
        <Grid item xs={11} textAlign="initial" paddingX={2}>
          <StyledText>{specification.description}</StyledText>
          <br />
          {specification.extendedDescription}
          {` ${specification.partNumber}`}
          {specification?.years &&
            `, ${Translate('years')}: ${specification.years}`}
          <br />
          {specification.miscellaneousTexts?.map(
            (text, index) =>
              `${text} ${
                index <= specification.miscellaneousTexts.length ? '' : ', '
              }`
          )}
        </Grid>
        <Grid item xs={1} paddingX={3} style={{ textAlign: 'end' }}>
          <Delete
            onClick={() => {
              if (specification.hash) {
                removeSpecification(specification.hash)
              }
            }}
            style={{ cursor: 'pointer' }}
            htmlColor={defaultTheme.colors.red}
          />
        </Grid>
        <Grid />
      </StyledGrid>
    )
  }
)

const StyledGrid = styled(Grid)`
  box-shadow: inset 0px -1px 0px ${defaultTheme.colors.disabledButtonText};
`

const StyledText = styled.span`
  font-family: 'Roboto', serif;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
`
